import type { RefObject } from "react";
import { LifeBuoy } from "lucide-react";
import { cn } from "@/lib/utils";

interface HelpButtonProps {
  isOpen: boolean;
  onClick: () => void;
  buttonRef: RefObject<HTMLButtonElement>;
}

export default function HelpButton({ isOpen, onClick, buttonRef }: HelpButtonProps) {
  return (
    <button
      ref={buttonRef}
      type="button"
      onClick={onClick}
      className={cn(
        "group inline-flex items-center gap-2 rounded-full border border-border/70 bg-background/95 px-3 py-2 text-sm font-medium text-foreground shadow-lg shadow-black/5 backdrop-blur transition-all hover:bg-background",
        isOpen && "bg-muted"
      )}
      aria-label={isOpen ? "Sulje apuri" : "Avaa apuri"}
      aria-haspopup="dialog"
      aria-expanded={isOpen}
      aria-controls="help-widget-panel"
    >
      <span className="flex h-7 w-7 items-center justify-center rounded-full bg-primary/10 text-primary">
        <LifeBuoy className="h-4 w-4" aria-hidden="true" />
      </span>
      <span className="hidden sm:inline">Apuri</span>
    </button>
  );
}
